import { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import http from '../config/http-common';

export interface PermissionModel {
  functionId: number;
  functionName: string;
  parentId: number | null;
  roles: RolePermissionModel[];
}

export interface RolePermissionModel {
  roleId: number;
  roleName: string;
  permissionKey: number;
  permissionName: string;
  siamKey: string;
}

export const useRolePermissionStore = defineStore('role-permission', () => {
  const isLoading = ref(false);
  const error = ref<Error | unknown>(null);
  const allPermissions = ref([] as PermissionModel[]);

  const getAllPermissions = async () => {
    if (allPermissions.value && allPermissions.value.length > 0) {
      return allPermissions;
    }
    isLoading.value = true;

    try {
      error.value = null;
      const response: AxiosResponse<PermissionModel[]> = await http.get('/gateway-schemes/permission');
      allPermissions.value = response.data;
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
    return allPermissions;
  };

  const savePermissions = async (permissionsToSave: PermissionModel[]) => {
    isLoading.value = true;
    try {
      error.value = null;
      await http.post('/gateway-schemes/permission', permissionsToSave);
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    getAllPermissions,
    savePermissions,
    isLoading,
    error,
  };
});

export type RolePermissionStore = ReturnType<typeof useRolePermissionStore>;
